function NmiRedirect(container_id, error_message_id) {
  var self = this;

  this.container = $('#' + container_id);

  this.error_div = $('#' + error_message_id);
  this.debug_div = $('#' + container_id + '_debug');

  this.form1 = this.container.find('form.nmi_step1');
  this.form2 = this.container.find('form.nmi_step2');
  this.button = this.container.find('.nmi_submit');

  this.button.click(function(){
    if (Payment.verifyCC(self.container)) {
      self.post_step1();
    }

  });
}

NmiRedirect.prototype.validate = function() {
  // Verify that all input fields have values
  var self = this;
  var valid = true;
  this.container.find('.nmi-required').each(function() {
    var val = $(this).val();
    if (val === null || /^\s*$/.test(val)) {
      self.error_div.html('Please enter all required fields.');
      valid = false;
      self.button.buttonState('reset');
      return false;
    }
  });
  return valid;
};

NmiRedirect.prototype.post_step1 = function() {
  var self = this;

  this.error_div.empty();

  if (!this.validate()) {

    return;
  }

  this.button.buttonState('loading');

  $.ajax({type: 'POST',
    url: this.form1.attr('action'),
    data: this.form1.serialize(),
    success: function(data) {
      self.step1_success(data);
    },
    error: function() {
      self.step1_error();
    },
    dataType: 'json'
  });
};

NmiRedirect.prototype.step1_success = function(data) {
  if (data.form_url === null || data.error_message !== null) {
    this.error_div.append(data.error_message);
    this.debug_div.append('<br/>step 1: ' + data.gateway_message);
  } else {
    this.form2.attr('action', data.form_url);

    // Populate the account name with first and last
    var first = this.container.find('input[name="billing-first-name"]').val();
    var last = this.container.find('input[name="billing-last-name"]').val();
    var name = first + ' ' + last;
    this.container.find('input[name="billing-account-name"]').val(name);

    // Populate the expiration date
    var mm_yy = this.container.find('select[name="nmi[ccexp(2i)]"]').val() + '/' + this.container.find('select[name="nmi[ccexp(1i)]"]').val();
    this.container.find('input[name="billing-cc-exp"]').val(mm_yy);

    this.form2.submit();
  }
};

NmiRedirect.prototype.step1_error = function() {
  this.error_div.append('There was an error processing your request. Please try again later.');
  this.debug_div.append('<br/>Server error');
  this.button.buttonState('reset');
};

global.NmiRedirect = global.NmiRedirect || NmiRedirect;
